import React, {Fragment, useState} from 'react';
import {NavLink} from 'react-router-dom';

import withClass from '../../../../hoc/withClass';
import {ACTIVE_LINK_COLOR} from '../../../../constants';

const Aside = props => {

    const [currentState] = useState({
        navItems: [
            {
                name: 'General',
                url: 'general',
                icon: 'fa-cogs'
            },
            {
                name: 'Password',
                url: 'passwords',
                icon: 'fa-key'
            },
            {
                name: 'Email',
                url: 'emails',
                icon: 'md-email-open'
            },
            {
                name: 'Notification',
                url: 'notifications',
                icon: 'md-notifications-active'
            },
            {
                name: 'System color',
                url: 'translations',
                icon: 'md-invert-colors'
            },
            {
                name: 'App menu color',
                url: 'colors',
                icon: 'md-format-color-fill'
            },
            {
                name: 'Institution',
                url: 'institutions',
                icon: 'md-graduation-cap'
            },
            {
                name: 'Certification',
                url: 'certification',
                icon: 'fa-certificate'
            },
            {
                name: 'Company',
                url: 'companies',
                icon: 'fa-industry'
            },
            {
                name: 'User hierarchy',
                url: 'hierarchies',
                icon: 'fa-sort-numeric-asc'
            },
            {
                name: 'Label translation',
                url: 'translations',
                icon: 'md-translate'
            }
        ]
    });

    return (
        <Fragment>
            <div className="page-aside-switch">
                <i className="icon md-chevron-left" aria-hidden="true"></i>
                <i className="icon md-chevron-right" aria-hidden="true"></i>
            </div>
            <div className="page-aside-inner">
                <div className="input-search">
                    <button className="input-search-btn" type="submit">
                        <i className="icon md-search" aria-hidden="true"></i>
                    </button>
                    <form autoComplete="off">
                        <input className="form-control" type="text" placeholder="Search system settings" name="" />
                    </form>
                </div>
                <div className="page-aside-scroll">
                    <div data-role="container">
                        <div data-role="content">
                            <section className="page-aside-section">
                                <div className="list-group">
                                    {currentState.navItems.map(item => {
                                        return (
                                            <NavLink key={item.name} to={`/settings/${item.url}`} className="list-group-item" activeStyle={{color: ACTIVE_LINK_COLOR, backgroundColor: '#eeeeee', border: 'none'}}>
                                                <i className={`icon icon-md ${item.icon}`} aria-hidden="true"></i>
                                                {`${item.name} settings`}
                                            </NavLink>
                                        );
                                    })}
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default withClass(Aside, 'page-aside');